import React from 'react'

const ProxyPrintContext = React.createContext()

export default ProxyPrintContext
